export default function checkoutPage () {
  const $ = jQuery;
  const $checkoutGuestBtn    = $( '.checkout-as-guest' );
  const $continueShippingBtn = $( '.continue-shipping__button' );
  const $continuePaymentBtn  = $( '.continue-payment__button' );
  const $checkoutColOne      = $( '.checkout-wrap .col-1' );
  const $checkoutColTwo      = $( '.checkout-wrap .col-2' );
  const $editShippingBtn     = $('.edit-shipping');
  const $shippingSummaryContent =  $( '.customer-shipping-summary p' );

  const initialPaymentSelection = $( '.payment-selector .input-radio:checked' ).val();
  if ( initialPaymentSelection == 'authorize_net_cim_credit_card' ) {
    $( '.accepted-cards' ).show();
  } else {
    $( '.accepted-cards' ).hide();
  }

  $( '.payment-selector .input-radio' ).on( 'change', function( e ) {

    if ( $(this).val() == 'authorize_net_cim_credit_card' ) {
      $('.accepted-cards' ).show();
    } else {
      $('.accepted-cards').hide();
    }
  });

  if ( validateShippingFields() == true ) {
    $( '.continue-shipping__button' ).removeAttr( 'disabled' );
  } else {
    $( '.continue-shipping__button' ).prop( 'disabled', true );
  }

  $( '.toggle-cart-review' ).on( 'click', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');

    $( '.woocommerce-checkout-review-order-table' ).toggle();
    $( '.your-cart-item' ).toggle();
  });

  $('.coupon__area .input-text').on( 'keyup blur focus', function( e ) {
    const couponCodeVal = $(this).val();
    $('#coupon_code').val( couponCodeVal );
    e.preventDefault();
  });

  $( '<span class="checkbox-custom"></span>' ).insertAfter( '.woocommerce form .input-checkbox');

  $( '.woocommerce-form-login #username' ).attr( 'placeholder', 'Email Address' );
  $( '.woocommerce-form-login #password' ).attr( 'placeholder', 'Password' );

  // Create an Account Header Text
  $('.woocommerce-account-fields').prepend( '<h4>Create an account</h4>' );

  // On Page Load, lets change the selected Shipping Method <li> class to active.
  $( '.woocommerce-shipping-methods input[type="radio"]:checked' ).parent().addClass( 'active' );

  // When a Shipping Method is focused , add the appropriate class to the parent element.
  $( '.woocommerce-shipping-methods input[type="radio"]' ).focus( function( e ) {
    $( '.woocommerce-shipping-methods li' ).removeClass('active');
    $( this ).parent().addClass('focus');
  });

  // When losing focus of a Currently Available Shipping Method on the Checkout Screen a.k.a On "Blur"
  $( '.woocommerce-shipping-methods input[type="radio"]' ).blur( function( e ) {
    $( this ).parent().removeClass('focus');
  });

  $( '.woocommerce-shipping-methods input[type="radio"]' ).on( 'change', function( e ) {
    $( '.woocommerce-shipping-methods li' ).removeClass( 'active' );
    $( this ).parent().addClass( 'active' );
  });

  $checkoutColTwo.addClass( 'disabled' );

  // Account Login -- Continue as Guest Button
  $checkoutGuestBtn.on( 'click', function( e ) {
    $( '.woocommerce-checkout' ).show();
    $( '.account-or-guest' ).hide();
    $( '.woocommerce-form-coupon-toggle' ).show();
    $( '.entry-title' ).show();
  });

  $( '.woocommerce-shipping-fields :input' ).on( 'keyup blur change', function( e ) {

    if ( validateShippingFields() == true ) {
      $( '.continue-shipping__button' ).removeAttr( 'disabled' );
    } else {
      $( '.continue-shipping__button' ).prop( 'disabled', true );
    }
    
    updateCustomerShippingSummary();
  });

  // Checkout form - Continue to Select Shipping Speed.
  $continueShippingBtn.on( 'click', function( e ) {
    e.preventDefault();
    checkoutStepTwo();
  });

  // If a user clicks "Edit" Lets go back to checkout Step one.
  $editShippingBtn.on( 'click', function( e ) {
    e.preventDefault();
    checkoutStepOne();

    $checkoutColTwo.addClass( 'disabled' );
  });

  function validateShippingFields() {
    let value = $( '.woocommerce-shipping-fields p.validate-required input, .woocommerce-shipping-fields p.validate-required select' ).filter(function () {
      return $.trim( $( this ).val() ).length == 0
    }).length == 0;

    return value;
  }

  $checkoutColOne.addClass('step-one');

  function checkoutStepOne() {
    $( '.shipping_address' ).show();
    $( '.woocommerce-account-fields' ).show();
    $( '.continue-payment' ).css( 'display', 'none' );
    $( '.order-timeline-notice' ).hide();
    $( '.select-shipping-speed' ).hide();
    $( '.nalgene-checkout-review-shipping-table' ).hide();
    $( '.customer-shipping-summary' ).hide();
    $( '.continue-shipping' ).show();
    $checkoutColOne.removeClass('disabled');
    $('.cart-get-free-shipping').hide();
  }

  function checkoutStepTwo() {
    $( '.shipping_address' ).hide();
    $( '.woocommerce-account-fields' ).hide();
    $( '.continue-payment' ).css( 'display', 'flex' );
    $( '.order-timeline-notice' ).show();
    $( '.select-shipping-speed' ).show();
    $( '.nalgene-checkout-review-shipping-table' ).show();
    $( '.customer-shipping-summary' ).show();
    $( '.continue-shipping' ).hide();
    $('.cart-get-free-shipping').show();
    $checkoutColOne.removeClass('step-one');
  }

  function checkoutStepThree() {
    $checkoutColTwo.removeClass( 'disabled' );
    $checkoutColOne.addClass( 'disabled' );
    $( '.woocommerce-checkout-payment' ).show();
    $( '.woocommerce-billing-fields' ).removeClass( 'active' );
    $('.cart-get-free-shipping').hide();
  }

  // Checkout Form - Continue to Payment Step
  $continuePaymentBtn.on( 'click', function( e ) {
    e.preventDefault();
    checkoutStepThree();
  });

  /**
   * Get Shipping Fields and add to Customers Shipping Address Summary
   * <div class="customer-shipping-summery"></div> <-- This div has the edit shipping button in it.
   */
  function updateCustomerShippingSummary() {
    const firstName          = $( '#shipping_first_name' ).val();
    const lastName           = $( '#shipping_last_name' ).val();
    const shippingAddressOne = $( '#shipping_address_1' ).val();
    const shippingAddressTwo = $( '#shipping_address_2' ).val();
    const city     = $( '#shipping_city' ).val();
    const state    = $( '#shipping_state' ).val();
    const postcode = $( '#shipping_postcode' ).val();
    const email    = $( '#billing_email' ).val();
    const phone    = $( '#billing_phone' ).val();
    $shippingSummaryContent.html( '' );

    const addressString =
    `${firstName} ${lastName} <br /> \n
     ${shippingAddressOne} ${shippingAddressTwo} <br /> \n
     ${city} ${state} ${postcode} <br /> \n
     ${email} <br /> \n
     ${phone} <br />
    `;

    $shippingSummaryContent.append( addressString );
  }
  updateCustomerShippingSummary();

  // Insert Arrow Icon SVG next to <select>
  $( '.woocommerce-checkout form select' ).after('<svg width="17" height="10" xmlns="http://www.w3.org/2000/svg"><path d="M8.415 10c-.441 0-.861-.189-1.153-.52L.722 2.045A1.23 1.23 0 012.57.42l5.72 6.502a.167.167 0 00.25 0L14.26.419a1.232 1.232 0 111.848 1.626L9.57 9.477A1.54 1.54 0 018.415 10z" fill="#898B89" fill-rule="nonzero"/></svg>');


  // When adding product to cart at checkout page, Get updated Shipping Options via AJAX.
  $( 'body' ).on( 'checkout_shipping_update', function() {
    if ( $( 'body' ).hasClass( 'woocommerce-checkout' ) ) {
      
      $( document.body ).trigger( 'update_checkout' );
    }
  });

}
